function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#7d7d7d;stroke:#7d7d7d;stroke-width:0.1px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.05 0.05)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M26.407,12.76h.086l4.16-.905a.409.409,0,0,0,.216-.108L37.916,4.7a2.716,2.716,0,0,0,.8-1.94A2.8,2.8,0,0,0,37.916.8a2.715,2.715,0,0,0-1.94-.8,2.651,2.651,0,0,0-1.94.819L27.01,7.867a.388.388,0,0,0-.129.194l-.905,4.16a.474.474,0,0,0,.129.41A.431.431,0,0,0,26.407,12.76ZM35.976.863a1.875,1.875,0,0,1,1.875,1.875q0,.011,0,.022a1.81,1.81,0,0,1-.539,1.315L34.662,1.4A1.853,1.853,0,0,1,35.976.863ZM34.058,2.027l2.651,2.651L30.567,10.8,27.916,8.169Zm-6.487,7L29.7,11.165l-2.737.6Z",
  transform: "translate(-25.222 0)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M22.709,365.717H8.269a.431.431,0,0,0,0,.862h14.44a.431.431,0,0,0,0-.862Z",
  transform: "translate(-7.838 -350.63)"
})));

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.402,
    height: 16.049,
    viewBox: "0 0 15.402 16.049",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.70f76f83.svg";
export { ForwardRef as ReactComponent };